export const PARCEL_RECALL = 'PARCEL_RECALL'
export const ORDER_CANCELLED = 'ORDER_CANCELLED'
export const INVALID_ORDER_TYPE = 'INVALID_ORDER_TYPE'
export const WRONG_LOCKER = 'WRONG_LOCKER'
export const NO_DELIVERY_MODE = 'NO_DELIVERY_MODE'
export const HAS_INCOMPLETE_ASSIGNMENTS = 'HAS_INCOMPLETE_ASSIGNMENTS'
export const NO_AVAILABLE_BOX = 'NO_AVAILABLE_BOX'
export const PARCEL_TOO_LARGE = 'PARCEL_TOO_LARGE'
export const BOX_WONT_OPEN = 'BOX_WONT_OPEN'
